import { useToastStore } from '../store/toastStore';
import Toast from './Toast';

export default function ToastContainer() {
  const { toasts, dismissToast } = useToastStore();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed z-[9999] right-2 bottom-2 sm:top-3 sm:bottom-auto sm:right-3 space-y-1.5 max-w-[90vw] sm:max-w-xs">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={dismissToast} />
      ))}
    </div>
  );
}
